export const hasText = (value: string | null | undefined): value is string =>
  value !== null && value !== undefined && value.length > 0
